import { z } from 'zod';

export const enum StoreEnum {
  /**
   * United States store
   */
  us = 'us',
  /**
   * US Multicurrency - AU / NZ
   */
  au = 'au',
  nz = 'nz',
  /**
   * Europe store
   */
  eu = 'eu',
  /**
   * United Kingdom store
   */
  uk = 'uk',
  /**
   * QA US store
   */
  qa = 'qa',
  dev = 'dev',
  /**
   * QA AU / NZ stores
   */
  aud = 'aud',
  nzd = 'nzd',
  /**
   * QA Europe store
   */
  eud = 'eud',
  /**
   * Japan store
   */
  jp = 'jp',
  /**
   * UK Dev store
   */
  ukd = 'ukd'
}

export const StoreOptions = [
  {
    label: '$ United States (USD)',
    shortLabel: '$USD',
    value: StoreEnum.us
  },
  {
    label: '$ Australia (AUD)',
    shortLabel: '$AUD',
    value: StoreEnum.au
  },
  {
    label: '$ New Zealand (NZD)',
    shortLabel: '$NZD',
    value: StoreEnum.nz
  },
  {
    label: '€ Euro (EUR)',
    shortLabel: '€EUR',
    value: StoreEnum.eu
  },
  {
    label: '£ United Kingdom (GBP)',
    shortLabel: '£GBP',
    value: StoreEnum.uk
  },
  {
    label: '¥ Japan (JPY)',
    shortLabel: 'JPY',
    value: StoreEnum.jp
  }
];

export const QAStoreOptions = [
  ...StoreOptions,
  {
    label: '⚒ US Dev',
    shortLabel: '⚒Dev',
    value: StoreEnum.dev
  },
  {
    label: '⚒ US QA',
    shortLabel: '⚒QA',
    value: StoreEnum.qa
  },
  {
    label: '⚒ AU QA',
    shortLabel: '⚒AUD',
    value: StoreEnum.aud
  },
  {
    label: '⚒ NZ QA',
    shortLabel: '⚒NZD',
    value: StoreEnum.nzd
  },
  {
    label: '⚒ EU Dev',
    shortLabel: '⚒EUD',
    value: StoreEnum.eud
  },
  {
    label: '⚒ UK Dev',
    shortLabel: '⚒UKD',
    value: StoreEnum.ukd
  }
];

export const storeCodeSchema = z.enum([
  'us',
  'au',
  'nz',
  'eu',
  'uk',
  'dev',
  'qa',
  'aud',
  'nzd',
  'eud',
  'ukd',
  'jp'
]);

export type StoreCode = z.infer<typeof storeCodeSchema>;

export const isValidStoreCode = (value: string): value is StoreCode =>
  storeCodeSchema.safeParse(value).success;

export const STORE_DEFAULT = storeCodeSchema.enum.us;

export const STORES_QA: Readonly<StoreCode[]> = [
  storeCodeSchema.enum.qa,
  storeCodeSchema.enum.dev,
  storeCodeSchema.enum.aud,
  storeCodeSchema.enum.nzd,
  storeCodeSchema.enum.eud,
  storeCodeSchema.enum.ukd
];

export const AU_NZ_STORES: Readonly<StoreCode[]> = [
  storeCodeSchema.enum.au,
  storeCodeSchema.enum.nz,
  storeCodeSchema.enum.aud,
  storeCodeSchema.enum.nzd
];
